<template>
<svg xmlns="http://www.w3.org/2000/svg" class="tw-fill-primary-light dark:tw-fill-primary-dark" viewBox="0 0 24 24"><path d="M21 11H3v2h18zm-7 8H3v2h11zm7-16H3v2h18zm0 13h-2v3h-3v2h3v3h2v-3h3v-2h-3z"/></svg>
</template>
